import fileSaver from 'file-saver';
import { SearchTerm } from '../models/search/SearchTerm';
import { MusteringReportTotals } from '../models/MusteringReportTotals';
import { Translator } from '../contexts/translator';
import { TranslationKeys } from '../contexts/TranslationKeys';

export const exportToCSV = async (
    filename: string,
    title: string,
    description: string,
    user: string,
    columnHeadings: any[],
    rows: any[],
    date: string,
    translate: Translator,
    appliedFilters?: string[],
    searchTerm?: SearchTerm,
    musteringTotals?: Promise<MusteringReportTotals | undefined>,
) => {
    const delimiter: string = ',';
    const recordCount: number = rows.length;
    let csvContent = `${translate.byKeyFormatted(TranslationKeys.titleWithTitle, { delimiter, title })}\r`;
    csvContent += `${translate.byKeyFormatted(TranslationKeys.descriptionWithDescription, {delimiter, description})}\r`;
    csvContent += `${translate.byKeyFormatted(TranslationKeys.userWithUser, { delimiter, user })}\r`;
    csvContent += `${translate.byKeyFormatted(TranslationKeys.dateWithDate, { delimiter, date })}\r`;
    csvContent += `${translate.byKeyFormatted(TranslationKeys.rowCountWithRowCount, { delimiter, recordCount })}\r`;

    if (appliedFilters?.length !== 0) {
        csvContent += `${translate.byKey(TranslationKeys.appliedFilters)}\r`;
        appliedFilters?.forEach((appliedFilter) => {
            csvContent += `,${appliedFilter}\r`;
        });
    }

    if (searchTerm?.value && searchTerm?.heading && searchTerm?.value !== "" && searchTerm?.heading !== "") {
        const searchTermValue: string = searchTerm?.value;
        const searchTermHeading: string = searchTerm?.heading;
        csvContent += `${translate.byKeyFormatted(TranslationKeys.appliedSearchTermAndHeadingWithAppliedSearchTermAndHeading, { delimiter, searchTermValue, searchTermHeading })}\r`;
    }

    const totals = await musteringTotals;
    if (totals) {
        const totalOnSite: number = totals.totalOnSite;
        const totalMustered: number = totals.totalMustered;
        const totalUnAccountedWithExited: number = totals.unaccountedWithExited;
        csvContent += `${translate.byKeyFormatted(TranslationKeys.totalPersonnelOnSiteWithValue, { delimiter, totalOnSite })}\r`;
        csvContent += `${translate.byKeyFormatted(TranslationKeys.totalPersonnelMusteredWithValue, { delimiter, totalMustered })}\r`;
        csvContent += `${translate.byKeyFormatted(TranslationKeys.totalPersonnelUnaccountedForWithValue, {delimiter, totalUnAccountedWithExited })}\r`;
    }

    csvContent += `\r\r${columnHeadings.join(',')}\r${convertToCSVFormat(rows)}`;

    // Add UTF-8 BOM to ensure proper encoding of Hebrew and other non-Latin characters
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' });
    fileSaver.saveAs(blob, `${filename}.csv`);
};

const convertToCSVFormat = (content: any[]): string => {
    let contentInCSVFormat: string = '';

    content.forEach((value) => {
        let tempContent = value.join(',');
        contentInCSVFormat += tempContent + '\r';
    });
    return contentInCSVFormat;
};
